import { postCompany } from '@/redux/actions/settingsActions.js';

const postSignupCompany = (data) => {
  return new Promise((resolve) => {
    postCompany(data, (response, error) => {
      if (error) {
        resolve({ success: false, error });
        return;
      }

      resolve({ success: true, data: response });
    });
  });
};

export default postSignupCompany;
